<template>
	<div id="app">
		<Navbar />
		<router-view />
	</div>
</template>

<script>
import Navbar from '@/components/navigation/Navbar'
export default {
	name: 'App',
	components: { Navbar },
}
</script>

<style>
#app {
	font-family: "Roboto Light", Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue